import QRCode from 'react-qr-code';

export { QRCode };
